import {useLocation} from '@reach/router';
import {SanityImageSource} from '@sanity/image-url/lib/types/types';

import React, {useMemo} from 'react';

import {imageUrlBuilder} from '_utils';

interface Props {
  sanityImage?: SanityImageSource | null;
  title?: string | null;
  description?: string | null;
  path?: string;
  index?: boolean;
  follow?: boolean;
}

export const SEO = ({title, description, sanityImage, path, index = true, follow = true}: Props) => {
  const location = useLocation();
  const canonicalUrl = `https://www.sunnyside.sg` + location.pathname;

  const seoTitle = useMemo(() => {
    return title ?? '';
  }, [title]);

  const seoDescription = useMemo(() => {
    return description ?? '';
  }, [description]);

  return (
    <>
      <meta name="robot" content={`${index ? `index`:`noindex`},${follow ? `follow`:`nofollow`}`}/>
      <meta name="title" content={seoTitle} />
      <meta property="og:title" content={seoTitle} />
      <meta name="description" content={seoDescription} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:url" content={canonicalUrl} />
      {sanityImage ? (
        <>
          <meta
            name="image"
            content={imageUrlBuilder.image(sanityImage).url()}
          />
          <meta
            property="og:image"
            content={imageUrlBuilder.image(sanityImage).url()}
          />
        </>
      ) : null}
      <link rel="canonical" href={canonicalUrl} />
    </>
  );
};

export default SEO;
